"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const events_1 = require("events");
const client_1 = tslib_1.__importDefault(require("@walletconnect/client"));
class StarkwareWalletConnectProvider {
    constructor(wc, opts = {}) {
        this._wc = null;
        this._debug = false;
        this._debugLog = (...args) => {
            if (!this._debug) {
                return;
            }
            console.debug('[stark-provider-wc]', ...args);
        };
        this._wc = wc;
        if (opts && opts.debug) {
            this._debug = true;
        }
    }
    setDebug(debug) {
        this._debug = debug;
    }
    enable() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._wc.accounts;
        });
    }
    sendRequest(method, params = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('sendRequest', method, params);
            const customRequest = {
                id: Date.now(),
                jsonrpc: '2.0',
                method,
                params,
            };
            if ((_a = this._wc) === null || _a === void 0 ? void 0 : _a.connector) {
                return (_c = (_b = this._wc) === null || _b === void 0 ? void 0 : _b.connector) === null || _c === void 0 ? void 0 : _c.sendCustomRequest(customRequest);
            }
            else if ((_d = this._wc) === null || _d === void 0 ? void 0 : _d._wc) {
                return (_f = (_e = this._wc) === null || _e === void 0 ? void 0 : _e._wc) === null || _f === void 0 ? void 0 : _f.sendCustomRequest(customRequest);
            }
            else if ((_g = this._wc) === null || _g === void 0 ? void 0 : _g.sendCustomRequest) {
                return (_h = this._wc) === null || _h === void 0 ? void 0 : _h.sendCustomRequest(customRequest);
            }
        });
    }
    account(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('account', layer, application, index);
            const { starkKey } = yield this.sendRequest('stark_account', {
                layer,
                application,
                index,
            });
            return starkKey;
        });
    }
    updateAccount(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('updateAccount', layer, application, index);
            yield this.sendRequest('stark_updateAccount', {
                layer,
                application,
                index,
            });
        });
    }
    requestAccounts() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('requestAccounts');
            const accounts = yield this.sendRequest('eth_requestAccounts');
            return accounts;
        });
    }
    personalSign(msg) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('personalSign', msg);
            let address = null;
            if ((_a = this._wc) === null || _a === void 0 ? void 0 : _a.connector) {
                address = (_c = (_b = this._wc) === null || _b === void 0 ? void 0 : _b.connector) === null || _c === void 0 ? void 0 : _c.accounts[0];
            }
            else if ((_d = this._wc) === null || _d === void 0 ? void 0 : _d._wc) {
                address = (_f = (_e = this._wc) === null || _e === void 0 ? void 0 : _e._wc) === null || _f === void 0 ? void 0 : _f.accounts[0];
            }
            else if ((_g = this._wc) === null || _g === void 0 ? void 0 : _g.accounts) {
                address = (_h = this._wc) === null || _h === void 0 ? void 0 : _h.accounts[0];
            }
            const signature = yield this.sendRequest('personal_sign', [msg, address]);
            return signature;
        });
    }
    registerUser(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('registerUser', params);
            const { txhash } = yield this.sendRequest('stark_register', params);
            return txhash;
        });
    }
    deposit(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('deposit', params);
            const { txhash } = yield this.sendRequest('stark_deposit', params);
            return txhash;
        });
    }
    withdraw(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('withdraw', params);
            const { txhash } = yield this.sendRequest('stark_withdraw', params);
            return txhash;
        });
    }
    transfer(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('transfer', params);
            const { starkSignature } = yield this.sendRequest('stark_transfer', params);
            return starkSignature;
        });
    }
    createOrder(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('createOrder', params);
            const { starkSignature } = yield this.sendRequest('stark_createOrder', params);
            return starkSignature;
        });
    }
    perpetualTransfer(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('perpetualTransfer', params);
            const { starkSignature } = yield this.sendRequest('stark_perpetualTransfer', params);
            return starkSignature;
        });
    }
    perpetualLimitOrder(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('perpetualLimitOrder', params);
            const { starkSignature } = yield this.sendRequest('stark_perpetualLimitOrder', params);
            return starkSignature;
        });
    }
    perpetualWithdrawal(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('perpetualWithdrawal', params);
            const { starkSignature } = yield this.sendRequest('stark_perpetualWithdrawal', params);
            return starkSignature;
        });
    }
}
exports.StarkwareWalletConnectProvider = StarkwareWalletConnectProvider;
class WalletConnectClientWrapper extends events_1.EventEmitter {
    constructor() {
        super();
        this._wc = null;
        const session = this.getSession();
        if (session) {
            const walletConnector = new client_1.default({ session });
            this._wc = walletConnector;
            this._setupEvenEmitter();
        }
    }
    _setupEvenEmitter() {
        var _a;
        const events = [
            'connect',
            'disconnect',
            'session_request',
            'session_update',
            'call_request',
            'wc_sessionRequest',
            'wc_sessionUpdate',
            'error',
            'transport_open',
            'transport_close',
        ];
        for (const name of events) {
            (_a = this._wc) === null || _a === void 0 ? void 0 : _a.on(name, (...args) => this.emit(name, ...args));
        }
    }
    get connected() {
        var _a;
        return !!((_a = this._wc) === null || _a === void 0 ? void 0 : _a.connected);
    }
    connect(connectUri) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._wc = new client_1.default({
                uri: connectUri,
            });
            if (!((_a = this._wc) === null || _a === void 0 ? void 0 : _a.connected)) {
                yield this.createSession();
            }
            this._setupEvenEmitter();
        });
    }
    createSession() {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.createSession();
    }
    killSession() {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.killSession();
    }
    approveSession(params) {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.approveSession(params);
    }
    rejectSession(params) {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.approveSession(params);
    }
    approveRequest(params) {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.approveRequest(params);
    }
    rejectRequest(params) {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.rejectRequest(params);
    }
    getSession() {
        try {
            const session = localStorage.getItem('walletconnect');
            if (!session) {
                return null;
            }
            return JSON.parse(session);
        }
        catch (err) {
            return null;
        }
    }
}
exports.WalletConnectClientWrapper = WalletConnectClientWrapper;
//# sourceMappingURL=StarkwareWalletConnectProvider.js.map